// extracted by mini-css-extract-plugin
module.exports = {"label":"FilterCustomOption_label__3kxmJ","optionSecondary":"FilterCustomOption_optionSecondary__338w_"};